
import { Directive, Input, ElementRef, Renderer2, OnChanges, HostListener, Output, EventEmitter } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector: '[appNullableBooleanClass]',
  standalone: true
})
export class NullableBooleanClassDirective implements OnChanges {

  @Input() appNullableBooleanClass: boolean | null | undefined;
  @Input() allowClickToggle: boolean = false;
  @Input() allowTrueFalseToggle: boolean = false;


  @Output() appNullableBooleanClassChange: EventEmitter<boolean | null | undefined> = new EventEmitter<boolean | null | undefined>();

  @HostListener('click') onClick(): void {
    if (this.allowClickToggle) {
      this.toggleValue();
      this.applyClasses();
      this.emitChange();
    }
  }

  protected readonly iconTrue = 'fa-square-check';
  protected readonly iconFalse = 'fa-square-xmark';
  protected readonly iconNull = 'fa-square';
  protected readonly iconBase = 'fa-light';

  constructor(protected el: ElementRef
    , protected renderer: Renderer2) { }

  ngOnChanges(): void {
    this.applyClasses();
  }

  private emitChange(): void {
    this.appNullableBooleanClassChange.emit(this.appNullableBooleanClass);
  }

  protected toggleValue(): void {

    if (this.appNullableBooleanClass === true) {

      if (this.allowTrueFalseToggle == true)
        this.appNullableBooleanClass = null;
      else
        this.appNullableBooleanClass = false;
    }
    else if (this.appNullableBooleanClass === false) {

      if (this.allowTrueFalseToggle == true)
        this.appNullableBooleanClass = true;
      else
        this.appNullableBooleanClass = null;
    }
    else {

      this.appNullableBooleanClass = true;
    }

  }

  protected applyClasses(): void {

    //const element = this.ngModel?.control?.parent?;


    if (this.appNullableBooleanClass === true) {

      if (this.el.nativeElement.classList.contains(this.iconFalse))
        this.renderer.removeClass(this.el.nativeElement, this.iconFalse);

      if (this.el.nativeElement.classList.contains(this.iconNull))
        this.renderer.removeClass(this.el.nativeElement, this.iconNull);

      this.renderer.addClass(this.el.nativeElement, this.iconBase);
      this.renderer.addClass(this.el.nativeElement, this.iconTrue);

    } else if (this.appNullableBooleanClass === false) {

      if (this.el.nativeElement.classList.contains(this.iconTrue))
        this.renderer.removeClass(this.el.nativeElement, this.iconTrue);

      if (this.el.nativeElement.classList.contains(this.iconNull))
        this.renderer.removeClass(this.el.nativeElement, this.iconNull);

      this.renderer.addClass(this.el.nativeElement, this.iconBase);
      this.renderer.addClass(this.el.nativeElement, this.iconFalse);

    } else {

      if (this.el.nativeElement.classList.contains(this.iconTrue))
        this.renderer.removeClass(this.el.nativeElement, this.iconTrue);

      if (this.el.nativeElement.classList.contains(this.iconFalse))
        this.renderer.removeClass(this.el.nativeElement, this.iconFalse);

      this.renderer.addClass(this.el.nativeElement, this.iconNull);
      this.renderer.addClass(this.el.nativeElement, this.iconBase);
    }

  }
}
